import { useIsSingleRecordQuery } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Stack, Typography } from '@mui/material';
import { IntermediateMeanFuncValue } from 'generated/graphql';
import { capitalize } from 'lodash';

interface MeanFormulaDefinitionParams {
  mean: Partial<IntermediateMeanFuncValue> & {
    value: number;
  };
}

export function MeanFormulaDefinition({ mean }: MeanFormulaDefinitionParams) {
  const measuredAsCriteria = useQuantifyStore(
    ({ query }) => query.formulaQuery?.criteria,
  );
  const isSingleRecordQuery = useIsSingleRecordQuery();

  if (isSingleRecordQuery) {
    return (
      <Stack>
        <Typography variant="caption">
          Mean:{' '}
          <Typography component="span" variant="inherit" fontWeight="bold">
            {mean.value}
          </Typography>
        </Typography>
        <Typography variant="caption">
          {`Sum of values  `}
          <Typography component="span" variant="inherit" fontWeight="bold">
            {mean.weightedSum ?? 0}
          </Typography>
          {` ÷ Total no. of values `}
          <Typography component="span" variant="inherit" fontWeight="bold">
            {mean.totalValue ?? 0}
          </Typography>
        </Typography>
      </Stack>
    );
  }

  const objectDisplayName = capitalize(measuredAsCriteria?.objectType);

  return (
    <Typography variant="caption">
      {`Mean: `}
      <Typography component="span" variant="inherit" fontWeight="bold">
        {mean.value}
      </Typography>
      {`  is derived by calculating the mean of `}
      <Typography component="span" variant="inherit" fontWeight="bold">
        {measuredAsCriteria?.displayName}
      </Typography>
      {` for all matching `}
      <Typography component="span" variant="inherit" fontWeight="bold">
        {objectDisplayName}
      </Typography>
      {`. `}
      <Typography component="span" variant="inherit" fontWeight="bold">
        {measuredAsCriteria?.displayName}
      </Typography>
      {` from ${objectDisplayName.toLowerCase().startsWith('a') ? 'an' : 'a'} `}
      <Typography component="span" variant="inherit" fontWeight="bold">
        {objectDisplayName}
      </Typography>
      {` is only counted once while calculating mean.`}
    </Typography>
  );
}
